import { Pipe, PipeTransform } from '@angular/core';
import { getObjectValue } from '@portals/utils';

@Pipe({
	name: 'object',
})
export class ObjectPipe implements PipeTransform {
	transform<T>(value: unknown, path: string): T {
		return getObjectValue(value, path);
	}
}
